import React, { useEffect } from "react"
import { useIntl } from "react-intl"
import Contents from "organisms/thanks/Contents"

const Thanks = ({ location }) => {
  // タブタイトルの作成
  const intl = useIntl()
  const title = intl.formatMessage({ id: "Tab.Title" })

  useEffect(() => {
    document.title = title
    window.scrollTo(0, 0)
  }, [title])

  return <Contents {...{ location }} />
}

export default Thanks
